import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";
import { useMemo } from "react";

const WvArrow: HTMLComponent<{
  direction: "l" | "r" | "t" | "b";
  color?: `border-${string}`;
  size?: "sm" | "md";
}> = ({ direction, size = "md", color = "border-darkblue", className }) => {
  const directionClass = useMemo(() => {
    return {
      l: "-rotate-135",
      r: "rotate-45",
      t: "-rotate-45",
      b: "rotate-135",
    }[direction];
  }, [direction]);
  const sizeClass = useMemo(() => {
    return {
      sm: "w-1.5 h-1.5",
      md: "w-2 h-2",
    }[size];
  }, [size]);
  return (
    <div
      className={classNames(
        directionClass,
        color,
        sizeClass,
        "relative border-t-2 border-r-2",
        className
      )}
    />
  );
};
export default WvArrow;
